/* node_modules */
import classNames from 'classnames/bind';
import propTypes from 'prop-types';
import React from 'react';
import { useLocation } from 'react-router';

import ConnectedFlashDrawer from '~/components/FlashDrawer';

/* local imports */
import Header from './Header';
/* style imports */
import styles from './Layout.scss';

const cx = classNames.bind(styles);

function Layout({ children }) {
  const { pathname } = useLocation();
  const isWatch = /watch/i.test(pathname);
  const isPollOverlay = /\/chat\/.+\/poll$/.test(pathname);
  const fullWidth =
    isWatch ||
    /chat/i.test(pathname) ||
    /admin/i.test(pathname) ||
    isPollOverlay;

  return (
    <div
      className={cx('Layout', {
        'Layout--noPadding': fullWidth,
        'Layout--transparent': isPollOverlay,
      })}
    >
      {!isPollOverlay && <Header />}
      <div
        className={cx('Layout__Container', {
          'Layout__Container--fullWidth': fullWidth,
        })}
      >
        {!isWatch && !isPollOverlay && <ConnectedFlashDrawer />}
        {children}
      </div>
    </div>
  );
}

Layout.propTypes = {
  children: propTypes.node.isRequired,
};

export default Layout;
